/**
 * 📅 UTILITÁRIOS DE DATA
 * Corrige problemas de fuso horário em todo o sistema
 */

/**
 * Retorna a data de HOJE no formato correto (YYYY-MM-DD)
 * Exemplo: "2025-11-04"
 *
 * POR QUE ISSO É NECESSÁRIO?
 * - JavaScript cria datas em UTC (horário universal)
 * - No Brasil, estamos UTC-3 (3 horas atrás)
 * - Sem correção, a data fica 1 dia adiantada
 */
export function getDataHoje(): string {
  const agora = new Date();
  // Ajusta o fuso horário subtraindo o offset em minutos
  const dataCorrigida = new Date(
    agora.getTime() - agora.getTimezoneOffset() * 60000
  );
  // Retorna no formato YYYY-MM-DD (ex: 2025-11-04)
  return dataCorrigida.toISOString().split("T")[0];
}

/**
 * Formata uma data ISO para o padrão brasileiro
 * Entrada: "2025-11-04"
 * Saída: "04/11/2025"
 */
export function formatarDataBR(dataISO: string): string {
  if (!dataISO) return "";

  const partes = dataISO.split("-");
  if (partes.length !== 3) return dataISO;

  const [ano, mes, dia] = partes;
  return `${dia}/${mes}/${ano}`;
}

/**
 * Formata uma data ISO completa (com hora) para BR
 * Entrada: "2025-11-04T18:30:00.000Z"
 * Saída: "04/11/2025 às 18:30"
 */
export function formatarDataHoraBR(dataISO: string): string {
  if (!dataISO) return "";

  const data = new Date(dataISO);
  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const ano = data.getFullYear();
  const hora = String(data.getHours()).padStart(2, "0");
  const minuto = String(data.getMinutes()).padStart(2, "0");

  return `${dia}/${mes}/${ano} às ${hora}:${minuto}`;
}

/**
 * Calcula a idade a partir da data de nascimento
 * Entrada: "1990-05-15"
 * Saída: 35 (idade em anos)
 */

/**
 * Formata uma data para formato DD-MM-AAAA
 * Entrada: Date ou string
 * Saída: "12-11-2025"
 */
export function formatarDataISO(data: Date | string): string {
  const dataCorrigida =
    typeof data === "string"
      ? data.includes("T")
        ? new Date(data)
        : new Date(`${data}T12:00:00`)
      : data;

  const dia = String(dataCorrigida.getDate()).padStart(2, "0");
  const mes = String(dataCorrigida.getMonth() + 1).padStart(2, "0");
  const ano = dataCorrigida.getFullYear();

  return `${dia}-${mes}-${ano}`;
}

export function calcularIdade(dataNascimento: string): number {
  if (!dataNascimento) return 0;
  // Fix timezone: ancora em meio-dia para evitar deslocamento UTC-3
  const dataCorrigida = dataNascimento.includes("T")
    ? dataNascimento
    : `${dataNascimento}T12:00:00`;
  const nascimento = new Date(dataCorrigida);
  const hoje = new Date();
  let idade = hoje.getFullYear() - nascimento.getFullYear();
  const mesAtual = hoje.getMonth();
  const mesNascimento = nascimento.getMonth();
  if (
    mesAtual < mesNascimento ||
    (mesAtual === mesNascimento && hoje.getDate() < nascimento.getDate())
  ) {
    idade--;
  }
  return idade;
}
export function getDataHoraAgora(): string {
  const agora = new Date();
  // Ajusta o fuso horário
  const dataCorrigida = new Date(
    agora.getTime() - agora.getTimezoneOffset() * 60000
  );
  // Retorna no formato ISO completo
  return dataCorrigida.toISOString();
}
